import { useHistory, useLocation, useParams } from 'react-router-dom';
import { removeTrailingSlash } from '../../utils/RoutingUtils';
import { COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT, SHORT_OVERVIEW_URL_FRAGMENT_PREFIX } from '../../constants/Navigation';
import { OVERVIEW_MODAL_PLAYLIST_PARAM } from '.';
export const removeOverviewUrl = path => {
  const overviewUrlFragmentIndex = Math.max(path.indexOf(COURSE_OVERVIEW_URL_FRAGMENT), path.indexOf(LESSON_OVERVIEW_URL_FRAGMENT), path.indexOf(SHORT_OVERVIEW_URL_FRAGMENT_PREFIX));
  return overviewUrlFragmentIndex !== -1 ? path.substring(0, overviewUrlFragmentIndex) : path;
};
export const getOverviewModalUrl = (currentPathname, isTrack, id, appearsIn, language) => {
  const appendedUrl = `${removeOverviewUrl(currentPathname)}/${isTrack ? 'course-overview' : 'lesson-overview'}/${id}${appearsIn ? `/${appearsIn}` : ''}${language ? `/${language.toUpperCase()}` : ''}`;
  return appendedUrl.replace('//', '/');
};
export const useOverviewNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    source
  } = useParams();
  const closeOverview = () => {
    const pathname = removeTrailingSlash(removeOverviewUrl(location.pathname)) || '/';
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(OVERVIEW_MODAL_PLAYLIST_PARAM)) searchParams.delete(OVERVIEW_MODAL_PLAYLIST_PARAM);
    history.replace(Object.assign({}, location, {
      pathname,
      search: searchParams.toString()
    }));
  };
  const goTo = ({
    id,
    type,
    language
  }) => {
    let sourceUrl = removeTrailingSlash(removeOverviewUrl(location.pathname));
    if (sourceUrl === '/') sourceUrl = '';
    const pathname = `${sourceUrl}${type === 'SHORT_FORM_CONTENT' ? SHORT_OVERVIEW_URL_FRAGMENT_PREFIX : type === 'TRACK' ? COURSE_OVERVIEW_URL_FRAGMENT : LESSON_OVERVIEW_URL_FRAGMENT}/${id}/${[source, language].filter(e => e).join('/')}`;
    history.push(Object.assign({}, location, {
      pathname
    }));
  };
  return {
    closeOverview,
    goTo
  };
};